$( document ).ready( function() {
    $(".input_file").on("change", function(e) {
        let fileName = "";
        fileName = e.target.value.split('\\').pop();
        if (fileName.length > 40 ) {
            fileName = fileName.substring(0, 40) + '...';
        }
        $("label[for='"+ this.id+"']").text(fileName);
        $("label[for='"+ this.id+"']").removeClass("btn-secondary").addClass("btn-success")
    })
});